import { notification } from 'antd'

let NotificationsUtils = {
    openErrorNotification: function (description: string) {
        notification['error']({
            message: 'Ошибка',
            description: description
        })
    },
    openSuccessNotification: function (description: string) {
        notification['success']({
            message: 'Успешно',
            description: description
        })
    }
}

export default NotificationsUtils
